import { Button, Dialog } from '../../../components/ui';
import { useLoi } from '../../../hooks/useLoi';
import { useT } from '../../../i18n';
import { LoiTrongHop } from '../../tenant/components/phan-form';

/**
 * Hộp xác nhận thao tác phá huỷ: tiêu đề đặt câu hỏi, thân nói hậu quả và tính không hoàn tác, nút nhắc lại việc sắp
 * làm. Lỗi hiện trong hộp, hộp không đóng.
 */
export function HopXacNhan({
  open,
  tieuDe,
  than,
  nhanXacNhan,
  nhanDangChay,
  dangChay,
  loi,
  onClose,
  onXacNhan,
}: {
  open: boolean;
  tieuDe: string;
  than: string;
  nhanXacNhan: string;
  nhanDangChay: string;
  dangChay: boolean;
  loi: unknown;
  onClose: () => void;
  onXacNhan: () => void;
}) {
  const { t } = useT();
  const dichLoi = useLoi();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={tieuDe}
      width={480}
      destroyOnHidden
      footer={
        <div className="flex flex-wrap justify-end gap-3">
          <Button variant="outline" size="md" onClick={onClose}>
            {t('chung.huy')}
          </Button>
          <Button variant="destructive" size="md" loading={dangChay} onClick={onXacNhan}>
            {dangChay ? nhanDangChay : nhanXacNhan}
          </Button>
        </div>
      }
    >
      <div className="space-y-3 pt-2">
        <p className="text-sm leading-relaxed text-content-secondary">{than}</p>
        {Boolean(loi) && <LoiTrongHop>{dichLoi(loi)}</LoiTrongHop>}
      </div>
    </Dialog>
  );
}
